module.exports = __webpack_public_path__ + "static/scale-model-of-ellen-kenna-house-in-oakland-california-0bda0bc64d4a4e571285fd1ec8cefef4.png";